// src/TaskPage.js
//
// UPDATED to full CRUD. Kept the live search box from the read-only
// version, added New/Edit/Delete. Uses activity_label for display.

import { useState, useEffect } from 'react';
import { API_BASE_URL } from './apiConfig';
import TaskForm from './TaskForm';

function TaskPage({ token }) {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editingTask, setEditingTask] = useState(null);

  const refreshTasks = () => {
    fetch(`${API_BASE_URL}/api/tasks/`, {
      headers: { Authorization: `Token ${token}` },
    })
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) setTasks(data);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshTasks();
  }, [token]);

  const filteredTasks = tasks.filter((t) =>
    t.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleNewClick = () => { setEditingTask(null); setShowForm(true); };
  const handleEditClick = (t) => { setEditingTask(t); setShowForm(true); };
  const handleSaved = () => { setShowForm(false); setEditingTask(null); refreshTasks(); };
  const handleCancel = () => { setShowForm(false); setEditingTask(null); };

  const handleDelete = async (t) => {
    const confirmed = window.confirm(`Delete task "${t.title}"? This cannot be undone.`);
    if (!confirmed) return;
    await fetch(`${API_BASE_URL}/api/tasks/${t.id}/`, {
      method: 'DELETE',
      headers: { Authorization: `Token ${token}` },
    });
    refreshTasks();
  };

  if (loading) return <p className="text-gray-500">Loading tasks...</p>;

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">Tasks</h1>
        <button onClick={handleNewClick} className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
          + New Task
        </button>
      </div>

      {showForm && (
        <TaskForm token={token} task={editingTask} onSaved={handleSaved} onCancel={handleCancel} />
      )}

      <input
        type="text"
        placeholder="Search tasks by title..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="border border-gray-300 rounded px-3 py-2 mb-4 w-full max-w-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
      />

      <table className="w-full bg-white rounded shadow">
        <thead>
          <tr className="text-left border-b">
            <th className="p-3">Title</th>
            <th className="p-3">Activity</th>
            <th className="p-3">Assigned To</th>
            <th className="p-3">Due Date</th>
            <th className="p-3">Status</th>
            <th className="p-3">Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredTasks.map((task) => (
            <tr key={task.id} className="border-b hover:bg-gray-50">
              <td className="p-3">{task.title}</td>
              <td className="p-3">{task.activity_label}</td>
              <td className="p-3">{task.assigned_to || 'N/A'}</td>
              <td className="p-3">{task.due_date || 'N/A'}</td>
              <td className="p-3">
                {task.is_completed ? (
                  <span className="bg-green-100 text-green-700 px-2 py-1 rounded text-sm">Completed</span>
                ) : (
                  <span className="bg-yellow-100 text-yellow-700 px-2 py-1 rounded text-sm">Pending</span>
                )}
              </td>
              <td className="p-3">
                <button onClick={() => handleEditClick(task)} className="text-blue-600 text-sm hover:underline mr-3">Edit</button>
                <button onClick={() => handleDelete(task)} className="text-red-600 text-sm hover:underline">Delete</button>
              </td>
            </tr>
          ))}
          {filteredTasks.length === 0 && (
            <tr><td className="p-3 text-gray-400" colSpan="6">No tasks match your search.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default TaskPage;
